export const initialState = {};

const getKeyWithDefault = (key, defaultReturnValue) => (state = initialState) => state[key] || defaultReturnValue;

export const getNationalities = getKeyWithDefault('nationalities', []);
export const getAges = getKeyWithDefault('categories', []);
export const getGenders = getKeyWithDefault('genders', []);
export const getSpecialNeeds = getKeyWithDefault('specialNeeds', []);
export const getDocumentTypes = getKeyWithDefault('documentTypes', []);
export const getTitles = getKeyWithDefault('titles', []);

export const getSalesOwnerName = getKeyWithDefault('name', '');
export const isVehicleRegNoMandatory = getKeyWithDefault('vehicleRegNoMandatory', false);



// WEBPACK FOOTER //
// ./src/store/market/selectors.js